import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import TagsInput from 'components/form/tagsinput'
import {
  cond,
  either,
  isNil,
  isEmpty,
  always,
  complement,
  map,
  split,
  flatten,
  pipe,
  concat,
  unless,
  startsWith,
  filter,
  defaultTo
} from 'ramda'
import withFieldError from 'components/form/with-error'

export const InstagramMentions = ({
  input: { value, onChange, ...input },
  meta: { error, touched }
}) => (
  <div className={error && touched && 'has-error'}>
    <TagsInput
      inputProps={{
        placeholder: 'Enter handle e.g. @handle',
        className: 'react-tagsinput-input input-medium',
        ...input,
        onBlur: input.onBlur.bind(input, value)
      }}
      addOnBlur
      value={value}
      onChange={onChange}
    />
  </div>
)

InstagramMentions.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const InstagramMentionsWithError = withFieldError(InstagramMentions)

const noValue = either(isNil, isEmpty)

export const validate = cond([[noValue, always('Please enter valid handles')]])

export const normalize = pipe(
  map(split(' ')),
  flatten,
  filter(complement(isEmpty)),
  map(unless(startsWith('@'), concat('@')))
)

const InstagramMentionsField = ({ name }) => (
  <div>
    <Field
      name={`${name}.handles`}
      component={InstagramMentionsWithError}
      validate={validate}
      format={defaultTo([])}
      normalize={normalize}
    />
    <Field name={`${name}.primary`} component='input' type='hidden' value />
  </div>
)

InstagramMentionsField.propTypes = {
  name: PropTypes.string
}

export default InstagramMentionsField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/instagram/mentions/index.js